export default __webpack_public_path__ + "img/e8fc7e9695cb155786dfa60bb3e0e237.png";